import script from "./NewChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewChat.vue?vue&type=script&setup=true&lang=ts"

import "./NewChat.vue?vue&type=style&index=0&id=323dcdf2&lang=scss&scoped=true"
import "./NewChat.vue?vue&type=style&index=1&id=323dcdf2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323dcdf2"]])

export default __exports__